import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { Plus } from 'lucide-react';
import '../../styles/buttons.css';

export interface CreateButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  /** ボタンの文言 (先頭の「+」は付けない。＋はチップで出す) */
  children: string;
  /** 平時は＋チップだけにし、ホバー / フォーカスで文言を伸ばす (btn-create-expand) */
  expand?: boolean;
}

/**
 * 新規作成ボタン (buttons.css の btn-create)。ページヘッダーの「新規ブランド作成」等に使う。
 * 角丸の本体の左端にアクセントカラーの＋チップを置く。
 */
export function CreateButton({
  children,
  expand = false,
  className = '',
  type = 'button',
  ...rest
}: CreateButtonProps): ReactNode {
  const classes = ['btn-create', expand ? 'btn-create-expand' : '', className].filter(Boolean).join(' ');
  return (
    <button
      type={type}
      className={classes}
      // 展開型は文言が見えない状態があるので読み上げ名を付ける
      aria-label={expand ? children : undefined}
      {...rest}
    >
      <span className="btn-create-chip">
        {/* 14px のチップ内では線幅 1 だと細すぎて＋が読めないため 1.5 にする (rules/icons.md の例外) */}
        <Plus size={14} aria-hidden="true" style={{ strokeWidth: 1.5 }} />
      </span>
      {expand ? <span className="btn-label">{children}</span> : children}
    </button>
  );
}
